// @flow
import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import { mergeSearch } from '../../redux/actions';
import DisclosureTypes from '../DisclosureTypes';

const IndividualDisclosureTypeSelect = ({ formName }) => {
    const dispatch = useDispatch();
    const types = useSelector((state) => state.FirstClassData.formStates[formName].formState.disclosure_types);

    const [disclosure_types, canAddAnotherDisclosureClause] = useMemo(() => {
        const canAddAnotherDisclosureClause = types.filter(row => {
                    return row.types.length === 0;
                }).length === 0;
        return [types, canAddAnotherDisclosureClause];
    }, [types]);

    const onFieldChange = (event, index) => {
        let disclosureTypes = disclosure_types.slice();
        disclosureTypes[index][event.target.name] = event.target.value;
        disclosureTypes[index]['label'] = event.target.label;
        dispatch(mergeSearch({ disclosure_types: disclosureTypes }, formName));
    };

    const onChange = (event, index) => {
        let disclosureTypes = disclosure_types.slice();
        disclosureTypes[index][event.target.name] = event.target.label;
        disclosureTypes[index]['disclosure_type_bool'] = event.target.value;
        dispatch(mergeSearch({ disclosure_types: disclosureTypes }, formName));
    };

    const handleIncludeExcludeClick = (exclude, index) => {
        let disclosureTypes = disclosure_types.slice();
        disclosureTypes[index].exclude = !exclude;
        dispatch(mergeSearch({ disclosure_types: disclosureTypes }, formName));
    };

    const handleDeleteButtonClick = (index) => {
        let disclosureTypes = disclosure_types.slice();
        disclosureTypes.splice(index, 1);
        dispatch(mergeSearch({ disclosure_types: disclosureTypes }, formName));
    };

    const handleAddDisclosureClause = () => {
        let disclosureTypes = disclosure_types.slice();
        disclosureTypes.push({
            exclude: false,
            disclosure_type_bool: 'or',
            types: []
        });
        dispatch(mergeSearch({ disclosure_types: disclosureTypes }, formName));
    };

    return (
        <Col lg={24}>
            {disclosure_types.map((DisclosureTypeClause, index) => (
                <Card className="my-1 license-groups-card-border" key={index}>
                    <CardHeader className="bg-light">
                        <a className="link"
                           onClick={() => handleIncludeExcludeClick(DisclosureTypeClause.exclude, index)}
                        >
                            {DisclosureTypeClause.exclude ? 'Exclude' : 'Include'}
                        </a>
                        &nbsp;records matching these disclosure types:

                        {disclosure_types.length > 1 &&
                        <button
                            onClick={() => handleDeleteButtonClick(index)}
                            type="button"
                            className="close"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        }
                    </CardHeader>
                    <CardBody className="pt-1">
                        <Row>
                            <Col>
                                <FormGroup>
                                    {formName == 'rrIndivSearch' &&
                                    <Label>RR Disclosure Type(s)</Label>
                                    }
                                    {formName == 'riaIndivSearch' &&
                                    <Label>IAR Disclosure Type(s)</Label>
                                    }
                                    {formName == 'bdFirmSearch' &&
                                    <Label>BD Disclosure Type(s)</Label>
                                    }
                                    <DisclosureTypes name="types" multi={true}
                                                 formName={formName}
                                                  value={DisclosureTypeClause.types}
                                                  onChange={(event) => onFieldChange(event, index)} />

                                    {DisclosureTypeClause.types.length > 1 &&
                                    <div className="form-inline flex-row-reverse pt-1">
                                        <p>
                                            Search for customers has &nbsp;
                                            <Input type="select"
                                                   name="disclosure_type_bool"
                                                   bsSize="sm"
                                                   value={DisclosureTypeClause.disclosure_type_bool}
                                                   onChange={(event) => onChange(event, index)}>
                                                <option value="and">all of these disclosure types</option>
                                                <option value="or">any of these disclosure types</option>
                                            </Input>
                                        </p>
                                    </div>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            ))}
            {canAddAnotherDisclosureClause && (
                <Button
                    className="p-0 ml-3"
                    color="link"
                    onClick={handleAddDisclosureClause}>
                    + Add another Disclosure Type clause
                </Button>
            )}
        </Col>
    );
};

export default IndividualDisclosureTypeSelect;